import styled from '@emotion/styled';
import { CAREER_COLOR } from '@/components/domain/seminar/seminarDisplay';

/*
 * 세미나 상세 공용 스타일 — docs/seminar-format-spec.md "상세 페이지 확정 수치".
 * 모바일(≤768): 카드 좌우 12px(앱 컨테이너 8px + 4px) · 안 14px · 반경 12px · 1px #e5e7eb · 간격 8px.
 * PC: 최대 1160px 2단(1fr + 340px, 간격 20px), 카드 안 18px.
 */

export const MOBILE_MAX_WIDTH_PX: number = 768;
export const MOBILE_QUERY: string = `(max-width: ${MOBILE_MAX_WIDTH_PX}px)`;
const PC_MEDIA: string = `@media (min-width: ${MOBILE_MAX_WIDTH_PX + 1}px)`;

export const PRIMARY: string = CAREER_COLOR;
export const BORDER: string = '#e5e7eb';

export const DetailPage = styled.div`
  width: 100%;
  box-sizing: border-box;
  /* 위 8px = 카드 사이 간격과 같게(히어로가 헤더에 붙어 보이던 4px 보정) */
  padding: 8px 4px 24px;

  /* PC 폭은 앱 본문 컨테이너(헤더와 같은 1260·24)를 그대로 쓴다 — 1160 으로 줄여 헤더보다 26px 안쪽이던 것(채용 상세와 맞춤, 2026-10-11) */
  ${PC_MEDIA} {
    margin: 16px 0 32px;
    padding: 0;
    display: grid;
    grid-template-columns: minmax(0, 1fr) 340px;
    column-gap: 20px;
    align-items: start;
  }
`;

export const MainColumn = styled.div`
  min-width: 0;
`;

/** PC 오른쪽 요약 — 머리글(sticky, 높이 124px) 아래 16px 에 붙는다. 88px 이면 위 36px 가 머리글에 가려졌다 */
export const SideColumn = styled.aside`
  position: sticky;
  top: 140px;
  min-width: 0;
`;

export const DCard = styled.section`
  background: #fff;
  border: 1px solid ${BORDER};
  border-radius: 12px;
  padding: 14px;
  margin-top: 8px;
  box-sizing: border-box;
  min-width: 0;
  overflow: hidden;

  ${PC_MEDIA} {
    padding: 18px;
    margin-top: 12px;
  }
`;

export const DCardTitle = styled.h2`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  margin: 0 0 10px;
  font-size: 15px;
  font-weight: 800;
  line-height: 1.4;
  color: #111827;
`;

/** 카드 제목 줄 오른쪽 끝 링크 — 쿠폰 카드 "더보기 ›"와 같은 자리·같은 모양(바깥 페이지로 나가는 링크용) */
export const DCardTitleLink = styled.a`
  padding: 4px 0 4px 8px;
  color: #6b7280;
  font-size: 13px;
  font-weight: 600;
  text-decoration: none;
  white-space: nowrap;

  &:focus-visible {
    outline: 2px solid ${PRIMARY};
    outline-offset: 2px;
    border-radius: 4px;
  }
`;

/** 정보 표 — 라벨 고정폭 + 값 */
export const KvGrid = styled.dl<{ labelWidth: number }>`
  display: grid;
  grid-template-columns: ${({ labelWidth }) => labelWidth}px minmax(0, 1fr);
  row-gap: 10px;
  column-gap: 8px;
  margin: 0;
  font-size: 14px;
  line-height: 1.5;

  dt {
    margin: 0;
    color: #6b7280;
    font-weight: 600;
  }

  dd {
    margin: 0;
    min-width: 0;
    color: #111827;
    word-break: keep-all;
    overflow-wrap: anywhere;
  }
`;

export const MutedText = styled.span`
  color: #9ca3af;
`;

/** "외부 접수" 회색 라벨 */
export const ExternalLabel = styled.span`
  display: inline-block;
  margin-left: 6px;
  padding: 2px 6px;
  border-radius: 4px;
  background: #f3f4f6;
  color: #6b7280;
  font-size: 11px;
  font-weight: 700;
  line-height: 1.4;
  vertical-align: middle;
`;

/** 화면 맨 아래 안내 — 문장마다 줄바꿈 */
export const FootNote = styled.div`
  margin-top: 12px;
  font-size: 12px;
  line-height: 1.7;
  color: #9ca3af;
  word-break: keep-all;
`;

export const PrimaryButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  border: none;
  border-radius: 12px;
  background: ${PRIMARY};
  color: #fff;
  font-family: inherit;
  font-size: 16px;
  font-weight: 800;
  cursor: pointer;

  &:disabled {
    background: #d1d5db;
    cursor: default;
  }
`;

export const SecondaryButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  border: 1px solid ${BORDER};
  border-radius: 12px;
  background: #fff;
  color: #374151;
  font-family: inherit;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
`;
